export default "__VITE_ASSET__ogEFyx6L__"